import React, { useContext } from "react";
import PropTypes from "prop-types";
import { RightsContext } from "providers/RightsContext";
import { hasAuthorization } from "utils/functions";
import * as rightsCodes from "constants/rightsCodes";
import { useTranslation } from "react-i18next";
import { IconButton } from "@totalsoft/rocket-ui";

const HeaderLinks = ({ onAdd }) => {
  const { t } = useTranslation();
  const rights = useContext(RightsContext);
  const hasWritePermission = hasAuthorization(rightsCodes.MASTER_PARTNER_HIERARCHIES_WRITE, rights);

  return !hasWritePermission ? null : (
    <IconButton id="hierarchyList_addBtn" type="add" onClick={onAdd} color="transparent" fontSize="medium" tooltip={t("PartnerHierarchy.AddHierarchy")}/>
  );
};

HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
